/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const ROOT = '/permits';

export const permitRoute = (permitId = ':permitId') => `${ROOT}/${permitId}`;
export const venuePageRoute = permitRoute;

export const availabilityPageRoute = (
    permitId = ':permitId',
    type = ':type',
    date = ':date',
    groupSize = ':groupSize',
    reservationId
) =>
    `${permitRoute(permitId)}/availability/${type}/${date}/${groupSize}${reservationId ? `?reservation_id=${reservationId}` : ''}`;

export const lotteryRegistrationRoute = (
    permitId = ':permitId',
    lotteryId = ':lotteryId',
    reservationId = ':reservationId'
) => `${permitRoute(permitId)}/lottery/${lotteryId}/registration/${reservationId}`;

export const orderDetailsPageRoute = (
    permitId = ':permitId',
    reservationId = ':reservationId'
) => `${permitRoute(permitId)}/registration/${reservationId}`;

export const lotteryWinnerConfirmationPageRoute = (permitId = ':permitId') =>
    `${permitRoute(permitId)}/lotteries/awarded`;

const childRoutes = [
    // Venue Page
    {
        path: '/permits/:permitId',
        componentName: 'VenuePage',
        title: 'Venue Details',
    },

    // Detailed Availability
    {
        path: '/permits/:permitId/availability/:type/:date/:groupSize',
        componentName: 'AvailabilityPage',
        title: 'Detailed Availability',
    },

    // Lottery Registration
    {
        path: '/permits/:permitId/lottery/:lotteryId/registration/:reservationId',
        componentName: 'LotteryRegistrationPage',
        title: 'Lottery Registration',
    },

    // Order Details
    {
        path: '/permits/:permitId/registration/:reservationId',
        componentName: 'OrderDetailsPage',
        title: 'Order Details',
    },

    // Lottery Winner Confirmation
    {
        path: '/permits/:permitId/lotteries/awarded',
        componentName: 'LotteryWinnerConfirmationPage',
        title: 'Lottery Winner Confirmation',
    },
];

export default childRoutes;
